export const emailPattern =
  /^[A-Za-z0-9\u4e00-\u9fa5_-]+(\.[A-Za-z0-9\u4e00-\u9fa5_-]+)*@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;

// 国内手机号
export const phonePattern =
  /^1[34578]\d{9}$/;

export const employeeRelations = [
  {
    value: '1',
    name: '大疆在职员工在我司投资或兼职'
  },
  {
    value: '2',
    name: '大疆在职员工主要亲属在我司投资'
  },
  {
    value: '3',
    name: '大疆在职员工主要亲属在我司任高管'
  },
  {
    value: '4',
    name: '大疆在职员工主要亲属在我司任大疆业务接口人'
  },
  {
    value: '5',
    name: '大疆前员工在我司投资'
  },
  {
    value: '6',
    name: '大疆前员工在我司任高管'
  },
  {
    value: '7',
    name: '大疆前员工在我司任大疆业务接口'
  },
  {
    value: '8',
    name: '其他'
  },
];

export const companyCaterory = [
  {
    value: 'Original',
    name: '原厂'
  },
  {
    value: 'Agent',
    name: '代理商'
  },
  {
    value: 'Manufacturer',
    name: '制造商'
  },
  {
    value: 'SpotTrader',
    name: '现货贸易商'
  },
  {
    value: 'Other',
    name: '其他'
  },
];

export const transationCurrency = [
  {
    value: 'rmb',
    name: '人民币'
  },
  {
    value: 'dollar',
    name: '美金'
  },
];

export const taxRate = [
  {
    value: 0,
    name: '0%'
  },
  {
    value: 6,
    name: '6%'
  },
  {
    value: 13,
    name: '13%'
  },
  {
    value: 16,
    name: '16%'
  },
];

export const job = [
  {
    value: 'manager',
    name: '总经理'
  },
  {
    value: 'business',
    name: '业务'
  },
  // {
  //   value: 'technology',
  //   name: '技术'
  // },
  // {
  //   value: 'quality',
  //   name: '品质'
  // },
];
export const relationshipWherter = [
  {
    value: 1,
    name: '是'
  },
  {
    value: 0,
    name: '否'
  },

];
export const supplyCategory = [
  {
    value: 1,
    name: '电子料'
  },
  {
    value: 2,
    name: '五金类'
  },
  {
    value: 3,
    name: '包装类'
  },
  {
    value: 4,
    name: '塑胶类'
  },
  {
    value: 5,
    name: '线材'
  },
  {
    value: 6,
    name: 'PCB'
  },
];

export const supportFileType = ['jpg', 'jpeg', 'png', 'pdf'];

export const qualification = [
  // {
  //   value: 'normalCertificate',
  //   name: '一般纳税人资格证书'
  // },
  // {
  //   value: 'businessCertificate',
  //   name: '商业、营利事业部登记'
  // },
  {
    value: 'proxyCertificate',
    name: '代理证书或原厂授权函'
  },
  // {
  //   value: 'iso',
  //   name: 'ISO900&ISO9001'
  // },
  // {
  //   value: 'TS16949',
  //   name: 'TS16949'
  // },
  // {
  //   value: 'TL9000',
  //   name: 'TL9000'
  // },
  // {
  //   value: 'ISO14000',
  //   name: 'ISO14000'
  // },
  // {
  //   value: 'OHSAS18000',
  //   name: 'OHSAS18000'
  // },
];

export const qualificationTypeSelect = [
  {
    value: '002',
    name: '测试证书',
  },
  {
    value: '003',
    name: '资质证书',
  },
  {
    value: '006',
    name: '道路运输经营许可证',
  },
  {
    value: '001',
    name: '生产许可证',
  },
  {
    value: '004',
    name: '质量体系认证',
  },
  {
    value: '007',
    name: '卫生许可证',
  },
  {
    value: '005',
    name: '营业执照',
  },
];

export const qualificationSelectData = [
  {
    value: 'normalCertificate',
    name: '一般纳税人资格证书'
  },
  {
    value: 'businessCertificate',
    name: '商业、营利事业部登记'
  },
  {
    value: 'proxyCertificate',
    name: '代理证书或原厂授权函'
  },
  {
    value: 'iso',
    name: 'ISO900&ISO9001'
  },
  {
    value: 'TS16949',
    name: 'TS16949'
  },
  {
    value: 'TL9000',
    name: 'TL9000'
  },
  {
    value: 'ISO14000',
    name: 'ISO14000'
  },
  {
    value: 'OHSAS18000',
    name: 'OHSAS18000'
  },
  {
    value: 'Other',
    name: '其他'
  },
  {
    value: 'businessLicense',
    name: '营业执照',
  },
];

export const companyType = [
  {
    value: 'ENTITY',
    name: '实体'
  },
  {
    value: 'PERSON',
    name: '个人'
  },
];
